import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function SuggestForPurchaseForm() {
  return (
    <a href="/suggested_purchases">
      <FormattedMessage id="feedback_suggest_for_purchase_link" />
    </a>
  );
}



// WEBPACK FOOTER //
// ./app/components/feedback/category_forms/SuggestForPurchaseForm.jsx